<template>
  <div class="search-dropdown" v-if="search">
    <template v-if="items && items.length">
      <div v-if="isMobile" :style="{ opacity: loading ? 0.7 : 1 }" class="search-dropdown__items">
        <div v-for="(item, i) in items" :key="i" class="search-dropdown__item">
          <slot :item="item" />
        </div>
      </div>
      <div v-else :style="{ opacity: loading ? 0.7 : 1 }" class="search-dropdown__items--desktop">
        <ProductCardComponent v-for="(item, i) in items" :key="i" :data="item" />
      </div>
      <router-link v-if="total > 6" :to="route" class="btn btn--gray btn--md btn--with-icon">
        <span>Все результаты</span>
        <IconComponent name="arrow-right-1" />
      </router-link>
    </template>
    <span v-else-if="loading" class="search-dropdown__loading">
      <FileIconComponent name="loading" />
    </span>
    <span v-else>Ничего не найдено</span>
  </div>
</template>

<script>
import ProductCardComponent from "components/product/ProductCardComponent.vue";
import IconComponent from "components/IconComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";

export default {
  name: "SearchResultsDropdownComponent",
  components: { FileIconComponent, IconComponent, ProductCardComponent },
  props: {
    items: Array,
    total: Number,
    loading: Boolean,
    search: String,
    route: {
      type: Object,
      default() {
        return {
          name: "catalog",
        };
      },
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.isMobile = window.innerWidth <= 860;
  },
};
</script>

<style lang="stylus">
.search-dropdown {
  position absolute
  top 100%
  left 0
  right 0
  z-index 10
  background var(--white)
  border-radius 0 0 var(--main_radius) var(--main_radius)
  box-shadow: 0 10px 60px -15px rgba(0, 0, 0, 0.4);
  padding 20px
  opacity 0
  visibility hidden
  display flex
  flex-direction column
  align-items center
  gap 20px
  transition var(--transition)

  &__items {
    width: 100%
    display flex
    flex-direction column
    grid-gap 8px
    max-height 60vh
    overflow-y auto
		scrollbar-width: thin
    transition var(--transition)
    +above(861px) {
      display none
    }

    &--desktop {
      display grid
      grid-template-columns repeat(6, 1fr)
      grid-gap 30px
      +below(860px) {
        display none
      }
    }
  }

  &__item {
    flex-shrink 0
  }

  &__loading {
    display flex

    .file-icon {
      width 60px
      height 60px
      +below(480px) {
        width 35px
        height 35px
      }

      svg circle {
        stroke var(--main-color)
      }
    }
  }
}
</style>
